import store from '@/store'
import Aes from '@/utils/Aes'
import common from '@/common'

function encrypt(obj) {
    obj = common.clone(obj);
    obj.appId = "XSZY80d28e0682f846ee";
    let dateOffset = localStorage.getItem('dateOffset')
    obj.timestamp = new Date().getTime() + (dateOffset ? dateOffset * 1 : 0);
    let params = Aes.encrypt(obj);
    let newObj = { params, }
    // eslint-disable-next-line no-undef
    if (u_config.debug) {
        newObj['请求参数'] = obj
    }
    return newObj;
}

export default function api(fun, data, method) {
    let request = require('@/utils/request').default;
    var apiUrl = {
        employeeLogin: 'user/employeeLogin', // 手机和PC端口账号、手机号登录(账号绑定)
        getUserRolePageList: 'user/getUserRolePageList', // 用户菜单权限 
        getVerifyCode: 'user/getVerifyCode', //获取验证码

        listMedicinalMaterials: 'zysj/listMedicinalMaterials', // 中医世家中药材列表
        listMedicinalMaterialsDetail: 'zysj/listMedicinalMaterialsDetail', // 中医世家中药材详情
        listBooks: 'zysj/listBooks', // 中医世家中医书籍列表
        getBookDetail: 'zysj/getBookDetail', // 中医世家中医书籍详情
        exportBookList: 'zysj/exportBookList', // 中医世家中医书籍检索导出

        chatAnswersStream: 'chatgpt/chatAnswersStream', // chatGPT问答(流) 
        chatAnswersNew: 'chatgpt/chatAnswersNew', // chatGPT问答(gpt-3.5-turbo)
        chatGenImages: 'chatgpt/chatGenImages', // chatGPT生成图片
        chatVoiceToText: 'chatgpt/chatVoiceToText', // chatGPT语音转文字

        listChatGptSessionHistory: 'zysj/listChatGptSessionHistory', // 用户会话历史记录列表
        deleteChatGptSessionHistory: 'zysj/deleteChatGptSessionHistory', // 删除会话记录
        saveChatGptSessionHistory: 'zysj/saveChatGptSessionHistory', // 保存会话记录

        completions: 'chatgpt/completions', // chatGPT聊天
        // chatVoiceToText: 'chatgpt/chatVoiceToText', // chatGPT语音转文字
        // chatGenImages: 'chatgpt/chatGenImages', // chatGPT生成图片

        getArticleList: '/saasbaihui/getArticleList', //获取医学文章列表
        getWideUseDict: '/saasconfig/getWideUseDict',  //数据字典
        getCsgUserInformation: '/user/getCsgUserInformation',  //获取个人信息
        editCsgUserInformation: '/user/editCsgUserInformation',  //修改个人信息
        sendBindValidateCode: '/user/sendBindValidateCode',  //个人信息发送绑定手机验证码
        getCsgIntegralTask: '/user/getCsgIntegralTask',  //藏书阁-福报任务列表
        receiveIntegral: '/user/receiveIntegral',  //藏书阁-福报任务列表
        getUnlimitedQRCodeByUser: '/user/getUnlimitedQRCodeByUser',  //藏书阁-福报任务列表
        getUnlimitedQRCode: 'user/getUnlimitedQRCode', // 小程序二维码 
        getMiniInformation: 'user/getMiniInformation', // 藏书阁-获取登录/注册扫码返回信息
        csgMiniLogin: 'user/csgMiniLogin', // 藏书阁-小程序注册/登录

        csgMobileLogin: "user/csgMobileLogin", // 藏书阁-手机号注册/登录
		sendValidateCode: "user/sendValidateCode", // 铁粉之家-获取扫码返回信息
		viewArticle: "saasbaihui/viewArticle", // 文章浏览
		tokenLogin: "user/tokenLogin", // token一键登录接口 
    };
    let url = apiUrl[fun];
    let headers = {};
    headers['Authorization'] = store.getters.token;
    
    if(fun == "tokenLogin"){
        headers['Authorization'] = localStorage.getItem('tokenLogin')
    }
    switch (fun) {
        case 'getUserRolePageList':
        case 'employeeLogin':
        case 'getVerifyCode':
            {
                data = encrypt(data);
            }
            break;
        case 'editCsgUserInformation':
            {
                data = encrypt(data);
            }
            break;
        case 'getUnlimitedQRCodeByUser':
            {
                data = encrypt(data);
            }
            break;
        case 'sendBindValidateCode':
            {
                data = encrypt(data);
            }
        break;
    }
    switch (fun) {
        // case "listChatGptSessionHistory": 
        // case "deleteChatGptSessionHistory": 
        // case "saveChatGptSessionHistory": 
        case "completions": 
        case "chatGenImages": 
        case "chatAnswersStream": 
        case "chatVoiceToText": 
        case "chatAnswersNew": {
            // eslint-disable-next-line no-undef
            url = u_config.gptApi + url;
        } break;
    }

    if (method == 'get') {
        let arr = [];
        for (const key in data) {
            if (Object.hasOwnProperty.call(data, key)) {
                arr.push(`${key}=${data[key]}`)
            }
        }
        url += "?" + arr.join("&");
    }

    return request({
        headers,
        url,
        method: method ? method : 'post',
        data
    })
}